import React from 'react';
import { func, string } from 'prop-types';

import MissingDataPath from './MissingDataPath';
import getEntityKey from 'helpers/getEntityKey';
import entitiesPropType from '../LineChart/prop-types/entities';

/**
 * MissingDataTrendLines renders an array of path elements that show
 * interpolated trend lines.
 *
 * @param {Object} props React props
 * @param {Function} colorScale Configured d3-scale ordinalScale that returns
 *                              a color string
 * @param {String} dataKey The object key to use to find the value in each trend
 *                         line data point
 * @param {Function} path Configured d3-shape line generator
 *
 * @constructor
 *
 * @returns {Array} An array of path elements
 */
function MissingDataTrendLines(props: any): JSX.Element {
  const { colorScale, dataKey, trends, path } = props;

  return trends.map((trend: any) => {
    return (
      <MissingDataPath
        key={`trend-interpolation-path-${getEntityKey(trend)}`}
        trend={trend}
        path={path}
        valueKey={dataKey}
        stroke={colorScale(getEntityKey(trend))}
        strokeDasharray="4 4"
        opacity="0.6"
      />
    );
  });
}

MissingDataTrendLines.propTypes = {
  colorScale: func.isRequired,
  dataKey: string.isRequired,
  trends: entitiesPropType.isRequired,
  path: func.isRequired,
};

export default MissingDataTrendLines;
